import ActionsRenderer from './components/ActionsRenderer.vue'
import PotentialGrossCellRenderer from './components/PotentialGrossCellRenderer.vue'
import { columns, formatters } from '~/plugins/ag-grid'
import LinkCellRenderer from '~/plugins/ag-grid/ag-cell-renderers/LinkCellRenderer.vue'

export const components = {
  PotentialGrossCellRenderer,
  LinkCellRenderer,
  ActionsRenderer
}

const defaultColumns = [
  {
    colId: 'Stock #',
    filter: 'agTextColumnFilter',
    headerName: 'Stock #',
    field: 'stockNumber',
    cellRenderer: 'LinkCellRenderer',
    cellRendererParams: ({ data }) => ({
      newTab: true,
      to: { name: 'inventory.vehicle', params: { id: data.id } }
    })
  },
  {
    colId: 'VIN',
    headerName: 'VIN',
    field: 'vehicle.vin',
    filter: 'agTextColumnFilter'
  },
  {
    colId: 'List Price',
    headerName: 'List Price',
    field: 'price.listPrice.amount',
    ...columns.currencyColDef
  },
  {
    colId: 'Unit Cost',
    headerName: 'Unit Cost',
    field: 'price.unitCost.amount',
    ...columns.currencyColDef
  },
  {
    colId: 'ACV Guarantee',
    headerName: 'ACV Guarantee',
    field: 'acvValues.guarantee',
    ...columns.currencyColDef
  },
  {
    colId: 'Potential Gross',
    headerName: 'Potential Gross',
    cellRenderer: 'PotentialGrossCellRenderer',
    sort: 'desc',
    valueGetter: ({ data }) => {
      const guarantee = data?.acvValues?.guarantee
      const unitCost = data?.price?.unitCost?.amount

      if (!guarantee || !unitCost) return 0

      return guarantee - unitCost
    },
    ...columns.currencyColDef
  },
  {
    colId: 'Plan',
    headerName: 'Plan',
    field: 'planning.objective',
    valueFormatter: formatters.normalizeLabel
  },
  {
    colId: 'Mileage',
    headerName: 'Mileage',
    field: 'vehicle.odometer.value',
    ...columns.numericColDef
  },
  {
    colId: 'Age',
    headerName: 'Age',
    field: 'age',
    ...columns.numericColDef
  },
  {
    colId: 'Vehicle',
    filter: 'agTextColumnFilter',
    headerName: 'Vehicle',
    valueGetter: ({ data }) => {
      const { year, make, model, trim } = data.vehicle.ymmt
      return [year, make, model, trim].join(' ')
    },
    minWidth: 300,
    suppressSizeToFit: false
  },
  {
    colId: 'Actions',
    headerName: 'Actions',
    pinned: 'right',
    resizable: false,
    sortable: false,
    minWidth: 230,
    maxWidth: 230,
    cellClass: 'text-center',
    cellRenderer: 'ActionsRenderer',
    suppressHeaderMenuButton: true,
    suppressHeaderContextMenu: true,
    suppressHeaderFilterButton: true
  }
]

export default defaultColumns
